import SessionListView from "@/views/admin/sessions/SessionListView";

export default [
  {
    name: "pages.admin.sessions",
    path: "sessions",
    component: SessionListView
  },
  {
    name: "pages.admin.sessions.create",
    path: "sessions/create",
    component: () => import("@/views/admin/sessions/SessionCreateView")
  },
  {
    name: "pages.admin.sessions.show",
    path: "sessions/:id",
    component: () => import("@/views/admin/sessions/SessionDetailView")
  },
  {
    name: "pages.admin.sessions.edit",
    path: "sessions/:id/edit",
    component: () => import("@/views/admin/sessions/SessionEditView")
  }
];
